/**
 * „Hängt an" im Bereich *Dokumente* (`document-subject-picker`, Spec 09,
 * „Der Objektpicker") — dünner Wrapper um `components/EntityPicker` mit dem
 * neuen Suchmodus, analog zu `TaskCostCenterField`.
 *
 * Nicht am Objekt: Dort ist „Hängt an" fester Text (`document-subject`),
 * nicht wählbar (`ARCHITECTURE.md` 6.4, „aus dem Kontext anlegen") — das
 * rendert `DocumentSheet` selbst, ohne diese Komponente.
 *
 * „Eingang" ist die Vorbelegung und bleibt über den generischen
 * `extraOption` von `EntityPicker` erreichbar — Sentinel-Auswahl mit `id:
 * ''`, `subjectId` wird daraus beim Absenden `undefined`
 * (`DocumentSheet.tsx`).
 */

import { EntityPicker } from '@/components/EntityPicker'
import type { EntitySelection } from '@/components/EntityPicker'
import type { FieldError } from '@/components/FormField'

/** `ALLOWED_PARENT_KINDS["document"]` (`shared/hierarchy.py`) — die sechs
 * Arten, an die ein Dokument hängen darf (seit Spec 46c auch `meter`: Zähler
 * sind nicht im Baum und nur über die Suche wählbar). Kein Endpunkt liefert diese
 * Liste (sie steuert nur, welche `kind=`-Werte der Suchmodus mitgibt);
 * dieselbe Art von client-eigenem Bezeichnersatz wie `TAB_IDS` in
 * `router.tsx` — keine deutsche Bezeichnung, keine Fachregel. */
export const DOCUMENT_SUBJECT_KINDS = ['property', 'building', 'unit', 'contract', 'folder', 'meter'] as const

export const EINGANG_SELECTION: EntitySelection = { id: '', label: 'Eingang' }

interface DocumentSubjectFieldProps {
  readonly value: EntitySelection
  readonly onSelect: (entity: EntitySelection) => void
  readonly error: FieldError | undefined
}

export function DocumentSubjectField({ value, onSelect, error }: DocumentSubjectFieldProps) {
  return (
    <EntityPicker
      testId="document-subject-picker"
      label="Hängt an"
      apiField="subject_id"
      errorPrefix="document"
      value={value}
      onSelect={onSelect}
      error={error}
      searchable
      kinds={DOCUMENT_SUBJECT_KINDS}
      searchPlaceholder="Objekt oder Vertrag suchen"
      emptySearchTitle="Nichts gefunden."
      emptySearchHint="Auch Verträge lassen sich hier suchen."
      extraOption={{
        testId: 'document-subject-picker-none',
        label: 'Eingang',
        onSelect: () => {
          onSelect(EINGANG_SELECTION)
        },
      }}
    />
  )
}
